<template>
  <div class="comp-xl-operation-log">
    <operation-filter @cb="getFilterData" :allFields="allFields" />
    <div ref="listRef" :style="{ height: windowHeight }" :class="['operation-content', !list.length && !firstShow ? 'operation-content-empty' : '', scrollShow ? 'scroll-shadow-show' : '']">
      <template v-if="list.length || firstShow">
        <div :style="{ maxHeight: windowHeight }" @scroll="handleScroll" @mouseleave="mouseLeave" ref="listWrapRef" class="list-wrap">
          <template v-if="loading && firstShow">
            <ly-skeleton-operation />
          </template>
          <template v-else>
            <jw-list-item v-for="(item, index) of list" :key="item.traceId?.slice(-6)" class="operation-log-item">
              <operation-content :dataIndex="index" :data-info="item" :allFields="allFields" @cbRichText="getRichTxt" @cbSubForm="getSubForm" />
            </jw-list-item>
            <div ref="loadingTriggerRef">
              <div v-if="bottom" class="no-more-text">没有更多了</div>
              <div v-else-if="list.length > 0" class="loading-text">加载中...</div>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <jw-empty />
      </template>
    </div>

    <jw-modal modal-class="operation-log-info-modal" body-class="log-modal-body" :visible="showData.visible" @ok="handleOk" @cancel="handleCancel" title-align="start" title="数据日志" :width="'720px'" :body-style="{ maxHeight: '550px', minHeight: '200px', paddingTop: '16px', paddingBottom: '16px', overflow: 'hidden' }" :mask-closable="false" unmount-on-close :ok-loading="loading" :footer="false">
      <template v-if="showModalInfo.showType === 'richText'">
        <div class="operation-log-rich-wrap">
          <div class="operationlog-box rich-info-old">
            <div class="info-head">修改前:</div>
            <template v-if="showData.oldValue">
              <div class="rich-info-inner" v-html="showData.oldValue"></div>
            </template>
            <template v-else><jw-empty /></template>
          </div>
          <div class="operationlog-box rich-info-new">
            <div class="info-head">修改后:</div>
            <template v-if="showData.newValue">
              <div class="rich-info-inner" v-html="showData.newValue"></div>
            </template>
            <template v-else><jw-empty /></template>
          </div>
        </div>
      </template>
      <template v-if="showModalInfo.showType === 'subForm'">
        <div class="sub-form-tips">提示: 当整行为蓝色底色时代表新建子记录，当整行为红色底色时代表删除子记录，当整行无底色时代表修改子记录。</div>
        <fh-table :height="400" :hover="false" :row-class-name="rowClassName" :bordered="false" v-on="tPropsEvent" v-bind="tProps" :columns="subColumns" resizable uuid="operation-table" class="operation-table">
          <template v-for="(slotName, slotIndex) in slots" #[slotName]="{ row }" :key="slotIndex">
            <sub-form-inner :row="row" :slotName="slotName" :allFields="subFields" />
          </template>
        </fh-table>
      </template>
    </jw-modal>
  </div>
</template>

<script setup>
import { ref, reactive, inject, nextTick, onUnmounted, watch } from 'vue';
import OperationFilter from './components/operation-filter/index.vue';
import OperationContent from './components/operation-content/index.vue';
import { publicService } from '@/api/';
import { onMounted } from 'vue';
import useEventListener from '@/hooks/event-listener';
import useFhTable from '@/hooks/fh-table';
import SubFormInner from './components/sub-form-inner/sub-form-inner.vue';
import setScrollBar from '@/hooks/scrollbar-config';

const { scrollShow, handleScroll, mouseLeave } = setScrollBar();
console.log('scrollShow', scrollShow);
const { eventListener } = useEventListener();

const { tProps, tPropsEvent, setTProps, setTLoading } = useFhTable();

console.log('1-开始创建组件-setup');
const props = defineProps({
  businessId: {
    type: [String, Number],
    default: ''
  },
  entityId: {
    type: [String, Number],
    default: ''
  }
});

const listRef = ref();
const windowHeight = ref();
const showModalInfo = ref({
  showType: ''
});
const loading = ref(false);
const listWrapRef = ref(null);

const firstShow = ref(true);
const list = ref([]); // 数据源
const bottom = ref(false); //底部是否还有数据
const total = ref(1); //总条数
const allFields = ref([]);
const entity = ref(inject('detailParams').entity);
const subColumns = ref([]);
const subFields = ref([]);
const slots = ref([]); // 子表单插槽

const data = reactive({
  page: 1,
  operationUser: null,
  operationDate: null,
  operationType: null,
  operationFields: null,
  operationSource: null
});

const showData = reactive({
  visible: false,
  oldValue: null,
  newValue: null
});

const loadingTriggerRef = ref(null);
let observer = null;

// 创建观察器
const createObserver = () => {
  console.log('createObserver');
  observer = new IntersectionObserver(
    (entries) => {
      console.log('entries', entries);
      const target = entries[0];
      console.log('target', target);
      if (target.isIntersecting && !loading.value && !bottom.value) {
        loadMore();
      }
    },
    {
      root: listWrapRef.value,
      threshold: 0.1 // 当目标元素10%可见时触发
    }
  );

  if (loadingTriggerRef.value) {
    observer.observe(loadingTriggerRef.value);
  }
};

// 清理观察器
const cleanupObserver = () => {
  console.log('cleanupObserver');
  if (observer) {
    observer.disconnect();
    observer = null;
  }
};

const handleCancel = () => {
  showData.visible = false;
};

const getRichTxt = (richInfo) => {
  showModalInfo.value.showType = 'richText';
  console.log('富文本呢', richInfo);
  const { oldValue, newValue } = richInfo;
  showData.oldValue = oldValue;
  showData.newValue = newValue;
  showData.visible = true;
};
const getSubForm = (subFormInfo) => {
  showModalInfo.value.showType = 'subForm';

  setTLoading(false);
  const { result, columns } = subFormInfo;
  const dataList = result.map((rItem) => {
    return {
      ...rItem,
      ...rItem.fieldChangeDetails
    };
  });
  const tabColumns = columns.map((cItem) => {
    return {
      colKey: cItem.fieldKey,
      title: cItem.fieldName,
      width: 160
    };
  });
  setTProps({
    stickyHeader: 60,
    data: dataList,
    pagination: false,
    hoverable: false
  });
  subFields.value = columns;
  subColumns.value = tabColumns;
  slots.value = columns.map((cItem) => cItem.fieldKey);
  console.log('子组件返回', dataList);

  showData.visible = true;
};

const getData = async (params, isRefresh = false) => {
  loading.value = true;
  try {
    const json = await publicService.findBusinessOperationLog(params);
    firstShow.value = false;
    if (!json.error) {
      const res = json.result;
      total.value = res.total;
      if (data.page === 1) {
        list.value = res.records;
        //将nextTick顺位提前 防止极端情况接口调用完成判断逻辑完成，赋值期间页面被关闭，导致获取不到listWrapRef
        nextTick(() => {
          if (isRefresh && listWrapRef.value) {
            listWrapRef.value.scrollTop = 0;
          }
        });
      } else {
        list.value.push(...res.records);
      }
      if (res.pages > res?.current) {
        data.page += 1;
        bottom.value = false;
      } else {
        bottom.value = true;
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const rowClassName = ({ row }) => {
  if (row.type === 'ADD') {
    return 'add-row';
  }
  if (row.type === 'ABANDON') {
    return 'abandon-row';
  }
  return '';
};

const loadMore = async () => {
  const params = {
    entityId: props.entityId,
    businessId: props.businessId,
    operationUser: data.operationUser,
    operationDate: data.operationDate,
    operationSource: data.operationSource,
    operationType: data.operationType,
    operationFieldKeys: data.operationFields,
    page: data.page,
    size: 10
  };
  if (list.value.length < total.value) {
    await getData(params);
  } else {
    bottom.value = true;
  }
};

const getFilterData = (filterOptions) => {
  console.log('回调参数', filterOptions);
  const { operationDate, operationUser, operationSource, operationType, operationFields } = filterOptions;
  data.operationUser = operationUser;
  data.operationDate = operationDate;
  data.operationSource = operationSource;

  data.operationType = operationType;
  data.operationFields = operationFields;

  data.page = 1;
  list.value = [];
  total.value = 1;
  loadMore();
};

const outFresh = async () => {
  bottom.value = false;
  data.page = 1;
  total.value = 1;

  const params = {
    entityId: props.entityId,
    businessId: props.businessId,
    operationUser: data.operationUser,
    operationDate: data.operationDate,
    page: data.page,
    size: 10
  };

  await getData(params, true);
};

//获取对象下所有字段
const getField = async () => {
  try {
    const json = await publicService.getField({ id: entity.value, showDisabled: true });
    if (!json.error) {
      const res = json.result;
      allFields.value = res.records;
      console.log('获取所有字段1', allFields.value);
    } else {
      console.log(json.error);
    }
  } catch (error) {
    console.log(error);
  }
};

const eventListen = () => {
  const rect = listRef.value?.getBoundingClientRect();
  console.log('顶部高度计算33', rect.top);
  // windowHeight.value = window.innerHeight - rect.top - 16;
  windowHeight.value = '100%';
};
eventListener('resize', eventListen);

onMounted(() => {
  getField();
  loadMore();

  nextTick(() => {
    if (listRef.value) {
      // createObserver();
      const rect = listRef.value?.getBoundingClientRect();
      console.log('顶部高度计算22', rect.top);

      // windowHeight.value = window.innerHeight - rect.top - 16;
      windowHeight.value = '100%';
    }
  });
});

onUnmounted(() => {
  cleanupObserver();
});

//当数据更新时重新创建观察器
watch(list, () => {
  nextTick(() => {
    cleanupObserver();
    createObserver();
  });
});

defineExpose({
  outFresh
});

console.log('操作日志', data);
</script>
<style scoped lang="less">
@import './xl-operation-log.less';
</style>
